export type QuestionCategory = "maths" | "words" | "world";

export interface Question {
	id: string;
	category: QuestionCategory;
	prompt: string;
	choices: string[];
	/** Index into `choices`. `-1` on a question that has been redacted. */
	answer: number;
}

/**
 * Written for roughly age 9–11: one step of thinking, no trick wording, and
 * every wrong choice is a mistake a kid could plausibly make.
 */
export const QUESTIONS: readonly Question[] = [
	{
		id: "m1",
		category: "maths",
		prompt: "7 × 8",
		choices: ["54", "56", "48", "63"],
		answer: 1,
	},
	{
		id: "m2",
		category: "maths",
		prompt: "45 + 38",
		choices: ["73", "83", "84", "93"],
		answer: 1,
	},
	{
		id: "m3",
		category: "maths",
		prompt: "100 − 64",
		choices: ["46", "34", "36", "44"],
		answer: 2,
	},
	{
		id: "m4",
		category: "maths",
		prompt: "9 × 6",
		choices: ["54", "56", "45", "63"],
		answer: 0,
	},
	{
		id: "m5",
		category: "maths",
		prompt: "144 ÷ 12",
		choices: ["11", "14", "12", "16"],
		answer: 2,
	},
	{
		id: "m6",
		category: "maths",
		prompt: "Half of 86",
		choices: ["42", "43", "44", "48"],
		answer: 1,
	},
	{
		id: "m7",
		category: "maths",
		prompt: "25% of 80",
		choices: ["16", "20", "25", "40"],
		answer: 1,
	},
	{
		id: "m8",
		category: "maths",
		prompt: "12 × 11",
		choices: ["122", "132", "121", "144"],
		answer: 1,
	},
	{
		id: "m9",
		category: "maths",
		prompt: "How many minutes in 2½ hours?",
		choices: ["120", "125", "150", "180"],
		answer: 2,
	},
	{
		id: "m10",
		category: "maths",
		prompt: "The perimeter of a square with 7 cm sides",
		choices: ["14 cm", "21 cm", "28 cm", "49 cm"],
		answer: 2,
	},
	{
		id: "m11",
		category: "maths",
		prompt: "3 × 3 × 3",
		choices: ["9", "18", "27", "33"],
		answer: 2,
	},
	{
		id: "m12",
		category: "maths",
		prompt: "What comes next: 2, 4, 8, 16, …",
		choices: ["18", "24", "32", "20"],
		answer: 2,
	},
	{
		id: "m13",
		category: "maths",
		prompt: "The angles inside a triangle add up to",
		choices: ["90°", "180°", "270°", "360°"],
		answer: 1,
	},
	{
		id: "m14",
		category: "maths",
		prompt: "0.5 + 0.25",
		choices: ["0.7", "0.75", "0.30", "0.525"],
		answer: 1,
	},
	{
		id: "m15",
		category: "maths",
		prompt: "How many sides does a hexagon have?",
		choices: ["5", "6", "7", "8"],
		answer: 1,
	},
	{
		id: "m16",
		category: "maths",
		prompt: "6 × 7 + 8",
		choices: ["50", "48", "56", "42"],
		answer: 0,
	},
	{
		id: "m17",
		category: "maths",
		prompt: "Which number is the biggest?",
		choices: ["0.7", "0.07", "0.77", "0.707"],
		answer: 2,
	},
	{
		id: "m18",
		category: "maths",
		prompt: "84 ÷ 7",
		choices: ["11", "12", "13", "14"],
		answer: 1,
	},

	{
		id: "w1",
		category: "words",
		prompt: "The opposite of ancient",
		choices: ["modern", "elderly", "historic", "dusty"],
		answer: 0,
	},
	{
		id: "w2",
		category: "words",
		prompt: "Which word means very happy?",
		choices: ["anxious", "delighted", "curious", "polite"],
		answer: 1,
	},
	{
		id: "w3",
		category: "words",
		prompt: "Which spelling is correct?",
		choices: ["neccesary", "necesary", "necessary", "neccessary"],
		answer: 2,
	},
	{
		id: "w4",
		category: "words",
		prompt: "More than one mouse is",
		choices: ["mouses", "mice", "mices", "meese"],
		answer: 1,
	},
	{
		id: "w5",
		category: "words",
		prompt: "The opposite of generous",
		choices: ["kind", "selfish", "wealthy", "gentle"],
		answer: 1,
	},
	{
		id: "w6",
		category: "words",
		prompt: "A group of wolves is called a",
		choices: ["herd", "flock", "pack", "school"],
		answer: 2,
	},
	{
		id: "w7",
		category: "words",
		prompt: "Which one is a verb?",
		choices: ["jump", "table", "shiny", "quickly"],
		answer: 0,
	},
	{
		id: "w8",
		category: "words",
		prompt: "Enormous means",
		choices: ["tiny", "huge", "noisy", "smooth"],
		answer: 1,
	},
	{
		id: "w9",
		category: "words",
		prompt: "Which spelling is correct?",
		choices: ["beutiful", "beautifull", "beautiful", "beatiful"],
		answer: 2,
	},
	{
		id: "w10",
		category: "words",
		prompt: "The opposite of arrive",
		choices: ["depart", "return", "travel", "wait"],
		answer: 0,
	},
	{
		id: "w11",
		category: "words",
		prompt: "The past tense of catch",
		choices: ["catched", "caught", "cought", "catches"],
		answer: 1,
	},
	{
		id: "w12",
		category: "words",
		prompt: "Which one is an adjective?",
		choices: ["run", "shiny", "loudly", "bicycle"],
		answer: 1,
	},
	{
		id: "w13",
		category: "words",
		prompt: "More than one leaf is",
		choices: ["leafs", "leaves", "leafes", "leave"],
		answer: 1,
	},
	{
		id: "w14",
		category: "words",
		prompt: "Rapid means",
		choices: ["fast", "wet", "heavy", "late"],
		answer: 0,
	},
	{
		id: "w15",
		category: "words",
		prompt: "Which word rhymes with height?",
		choices: ["weight", "kite", "eight", "hit"],
		answer: 1,
	},

	{
		id: "g1",
		category: "world",
		prompt: "Which planet is called the Red Planet?",
		choices: ["Venus", "Mars", "Jupiter", "Mercury"],
		answer: 1,
	},
	{
		id: "g2",
		category: "world",
		prompt: "How many legs does a spider have?",
		choices: ["6", "8", "10", "12"],
		answer: 1,
	},
	{
		id: "g3",
		category: "world",
		prompt: "Water freezes at",
		choices: ["0 °C", "10 °C", "32 °C", "100 °C"],
		answer: 0,
	},
	{
		id: "g4",
		category: "world",
		prompt: "The largest ocean on Earth",
		choices: ["Atlantic", "Indian", "Pacific", "Arctic"],
		answer: 2,
	},
	{
		id: "g5",
		category: "world",
		prompt: "The fastest animal on land",
		choices: ["Horse", "Cheetah", "Ostrich", "Greyhound"],
		answer: 1,
	},
	{
		id: "g6",
		category: "world",
		prompt: "How many continents are there?",
		choices: ["5", "6", "7", "8"],
		answer: 2,
	},
	{
		id: "g7",
		category: "world",
		prompt: "What do bees make?",
		choices: ["silk", "honey", "milk", "wool"],
		answer: 1,
	},
	{
		id: "g8",
		category: "world",
		prompt: "The biggest planet in our solar system",
		choices: ["Saturn", "Neptune", "Jupiter", "Earth"],
		answer: 2,
	},
	{
		id: "g9",
		category: "world",
		prompt: "Which gas do plants take in from the air?",
		choices: ["oxygen", "carbon dioxide", "helium", "nitrogen"],
		answer: 1,
	},
	{
		id: "g10",
		category: "world",
		prompt: "How many days are in a leap year?",
		choices: ["364", "365", "366", "367"],
		answer: 2,
	},
];
